export default "__VITE_ASSET__DUS8pctW__"